import { DetailedHTMLProps, HTMLAttributes } from "react";

import { cn } from "@/styles/cn";

export function PageContainer({
  children,
  className,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  return (
    <div className={cn("flex h-full w-full flex-col", className)} {...props}>
      {children}
    </div>
  );
}
